import {EVENT_GLOBAL_ATTACH} from "base/FormValidator";
import GlobalEvents from "base/GlobalEvents";

GlobalEvents.on(EVENT_GLOBAL_ATTACH, (validator) => {
    validator.on("input:invalid", ({input}) => {
        input.$input.closest(".form__row").addClass("form__row--error");

        if (input.$input.is(":checkbox,:radio")) {
            input.$input.parents("fieldset").find("legend").addClass("form__legend--error");
        }

    }).on("input:valid", ({input}) => {
        input.$input.closest(".form__row").removeClass("form__row--error");

        if (input.$input.is(":checkbox,:radio")) {
            input.$input.parents("fieldset").find("legend").removeClass("form__legend--error");
        }
    });
});
